import request from "@/utils/request"


// 设备列表
export function DeviceList(page, pageSize, nameORnumber,userNameORuserUid) {
  return request({
    url: "/deviceuser/findDeviceuserPage",
    method: "POST",
    data: {
      page,
      pageSize,
      nameORnumber,
      userNameORuserUid
    }
  })
};

// 创建设备
export function addDevice(objectids,userid,selectedRowDUIds) {
  return request({
    url: "/deviceuser/addDeviceuser",
    method: "POST",
    data: {
      objectids,userid,selectedRowDUIds
    }
  })
};
// 全部授权
export function allAuthorize(userid) {
  return request({
    url: "/deviceuser/allAuthorize",
    method: "POST",
    data: {
      userid
    }
  })
};
// 全部解除
export function unAllAuthorize(userid) {
  return request({
    url: "/deviceuser/unAllAuthorize",
    method: "POST",
    data: {
      userid
    }
  })
};
// 激活设备授权
export function ActivateDevice(id) {
  return request({
    url: `/deviceuser/activate/${id}`,
    method: "POST",
    data: {}
  })
};
// 删除设备
export function DelDevice(id) {
  return request({
    url: `/deviceuser/deleteDeviceuserById/${id}`,
    method: "DELETE",
    data: {
      id
    }
  })
};
//查看设备信息
export function DeviceInfo(id) {
  return request({
    url: `/deviceuser/getDeviceuserById/${id}`,
    method: "GET",
    data: {
      id
    }
  })
};
// 修改设备信息
export function upDataDeviceInfo(id,objectid,userid) {
  return request({
    url: `/deviceuser/updateDeviceuser`,
    method: "PUT",
    data: {
      id,objectid,userid
    }
  })
}
